import React, { createContext, useState } from 'react';
export var CommonContext = createContext({
    showLoadingOverlay: false,
    setShowLoadingOverlay: function () { return null; },
});
export var CommonProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), showLoadingOverlay = _b[0], setShowLoadingOverlay = _b[1];
    return (React.createElement(CommonContext.Provider, { value: {
            showLoadingOverlay: showLoadingOverlay,
            setShowLoadingOverlay: setShowLoadingOverlay,
        } }, children));
};
export default CommonProvider;
